import { getSafeReturnUrl } from './getSafeReturnUrl';

interface IFinanceMortgageUrl {
  search?: string | null;
}

export function getFinanceMortgageUrl({ search }: IFinanceMortgageUrl): string {
  const searchParams = new URLSearchParams(search || '');
  const returnUrl = searchParams.get('returnUrl');
  const safeReturnUrl = getSafeReturnUrl(returnUrl);

  if (safeReturnUrl) {
    return safeReturnUrl;
  }

  searchParams.delete('returnUrl');
  searchParams.set('skip_welcome_page', 'true');

  return `https://www.cian.ru/cf/user-state-machine/route/entrypoint/?${searchParams}`;
}
